import axios from "axios";
import { AUTH_ENDPOINT } from "../config";

const instance = axios.create({ baseURL: AUTH_ENDPOINT });

export default instance;
